// src/authConfig.js
export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_AAD_CLIENT_ID, // SPA app (frontend) Client ID
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_AAD_TENANT_ID}`,
    // Trailing slash matches the SPA redirect URIs registered on the Entra app.
    redirectUri: process.env.REACT_APP_REDIRECT_URI || `${window.location.origin}/`,
    postLogoutRedirectUri: process.env.REACT_APP_POSTLOGOUT_URI || window.location.origin,
  },
  cache: { cacheLocation: "sessionStorage" },
};

export const loginRequest = {
  // If your backend exposes an API scope, set it via env; otherwise fallback to a harmless MS scope.
  scopes: [process.env.REACT_APP_AAD_SCOPE || "User.Read"],
};
